import { z } from 'zod';

export const AgreementTypeSchema = z
  .union([
    z.literal('SERVICE_TERMS').describe('29CM 서비스 이용 약관'),
    z.literal('SERVICE_POLICY').describe('29CM 서비스 운영 정책'),
    z.literal('SERVICE_TERMS_V1').describe('무신사 서비스 이용약관'),
    z.literal('SERVICE_TERMS_V2').describe('무신사 서비스 이용약관(개정)'),
    z.literal('SERVICE_POLICY_V1').describe('무신사 서비스 운영정책'),
    z.literal('PRIVACY_COLLECTION_V1').describe('개인정보 수집 및 이용 동의'),
  ])
  .describe(
    '큐레이터 이용약관 타입. MUSINSA는 V1/V2·운영정책·개인정보 수집, 29CM은 이용약관·운영정책 코드를 사용',
  );

export type AgreementType = z.infer<typeof AgreementTypeSchema>;

export const GetTermsAgreementsServiceResponseSchema = z
  .object({
    agreedTerms: z.array(AgreementTypeSchema),
  })
  .describe('GetTermsAgreementsServiceResponseSchema');

export type GetTermsAgreementsServiceResponse = z.infer<
  typeof GetTermsAgreementsServiceResponseSchema
>;

export const PostTermsAgreementsServiceRequestSchema = z
  .object({
    termsTypes: z.array(AgreementTypeSchema).min(1),
  })
  .describe('PostTermsAgreementsServiceRequestSchema');

export type PostTermsAgreementsServiceRequest = z.infer<
  typeof PostTermsAgreementsServiceRequestSchema
>;

export const PostTermsAgreementsServiceResponseSchema = z
  .object({
    agreedTerms: z.array(AgreementTypeSchema),
  })
  .describe('PostTermsAgreementsServiceResponseSchema');

export type PostTermsAgreementsServiceResponse = z.infer<
  typeof PostTermsAgreementsServiceResponseSchema
>;
